import { getConfigValue } from 'utils/environment/config';

export const PROD_DEFAULT_REGION = (getConfigValue({ key: 'buildRegion' }) ?? 'US').toUpperCase();
